import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterPanel = ({ filters, onFilterChange, onClearFilters, isOpen, onToggle }) => {
  const roleOptions = [
    { value: 'all', label: 'All Roles' },
    { value: 'Developer', label: 'Developer' },
    { value: 'Project Manager', label: 'Project Manager' },
    { value: 'Business Analyst', label: 'Business Analyst' },
    { value: 'Product Designer', label: 'Product Designer' }
  ];

  const experienceOptions = [
    { value: 'all', label: 'All Levels' },
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' }
  ];

  const availabilityOptions = [
    { value: 'all', label: 'Any Time' },
    { value: 'weekdays', label: 'Weekdays' },
    { value: 'weekends', label: 'Weekends' },
    { value: 'evenings', label: 'Evenings' },
    { value: 'flexible', label: 'Flexible' }
  ];

  const universityOptions = [
    { value: 'all', label: 'All Universities' },
    { value: 'Howard University', label: 'Howard University' },
    { value: 'Spelman College', label: 'Spelman College' },
    { value: 'Morehouse College', label: 'Morehouse College' },
    { value: 'North Carolina A&T', label: 'North Carolina A&T' },
    { value: 'Florida A&M University', label: 'Florida A&M University' }
  ];

  const handleFilterChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  const getActiveFilterCount = () => {
    let count = 0;
    if (filters?.role && filters?.role !== 'all') count++;
    if (filters?.experience && filters?.experience !== 'all') count++;
    if (filters?.availability && filters?.availability !== 'all') count++;
    if (filters?.university && filters?.university !== 'all') count++;
    if (filters?.skills && filters?.skills?.trim()) count++;
    if (filters?.onlineOnly) count++;
    if (filters?.hasTeamExperience) count++;
    return count;
  };

  return (
    <div className={`bg-card border border-border rounded-lg transition-all duration-300 ${
      isOpen ? 'p-6' : 'p-4'
    }`}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Icon name="Filter" size={20} className="text-muted-foreground" />
          <h3 className="font-medium text-foreground">Filters</h3>
          {getActiveFilterCount() > 0 && (
            <span className="px-2 py-1 text-xs bg-primary text-primary-foreground rounded-full">
              {getActiveFilterCount()}
            </span>
          )}
        </div>
        <div className="flex items-center space-x-2">
          {getActiveFilterCount() > 0 && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearFilters}
              iconName="X"
              iconPosition="left"
              iconSize={14}
            >
              Clear
            </Button>
          )}
          <Button
            variant="ghost"
            size="icon"
            onClick={onToggle}
            className="lg:hidden"
          >
            <Icon name={isOpen ? "ChevronUp" : "ChevronDown"} size={16} />
          </Button>
        </div>
      </div>
      <div className={`space-y-4 ${isOpen ? 'block' : 'hidden lg:block'}`}>
        {/* Role Filter */}
        <Select
          label="Role"
          options={roleOptions}
          value={filters?.role || 'all'}
          onChange={(value) => handleFilterChange('role', value)}
        />

        {/* Experience Level */}
        <Select
          label="Experience Level"
          options={experienceOptions}
          value={filters?.experience || 'all'}
          onChange={(value) => handleFilterChange('experience', value)}
        />

        {/* Availability */}
        <Select
          label="Availability"
          options={availabilityOptions}
          value={filters?.availability || 'all'}
          onChange={(value) => handleFilterChange('availability', value)}
        />

        {/* University */}
        <Select
          label="University"
          options={universityOptions}
          value={filters?.university || 'all'}
          onChange={(value) => handleFilterChange('university', value)}
          searchable
        />

        {/* Skills Search */}
        <Input
          label="Skills"
          type="text"
          placeholder="Search by skills (e.g., React, Python)"
          value={filters?.skills || ''}
          onChange={(e) => handleFilterChange('skills', e?.target?.value)}
        />

        {/* Additional Filters */}
        <div className="space-y-3 pt-2 border-t border-border">
          <Checkbox
            label="Online now"
            checked={filters?.onlineOnly || false}
            onChange={(e) => handleFilterChange('onlineOnly', e?.target?.checked)}
          />
          
          <Checkbox
            label="Has team experience"
            checked={filters?.hasTeamExperience || false}
            onChange={(e) => handleFilterChange('hasTeamExperience', e?.target?.checked)}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;